import { AddressOptionalLatLng } from "types/addresses";

export const formatAddress = (addr: AddressOptionalLatLng) => {
  return `${addr.building_no} ${addr.street}, ${addr.line2 ? `${addr.line2}, ` : "" } ${addr.city}, ${addr.postcode}`;
};